// extracted by mini-css-extract-plugin
export default {"feeCard":"FeeView_feeCard__dwoFz","feeTag":"FeeView_feeTag__quSq6"};